export default __webpack_public_path__ + "static/media/README.cb401065.md";